<p *ngIf="message" class="mc-no-item-placeholder-message" [ngClass]="size ? 'text-' + size : 'text-xx-large'">
  {{message}}
</p>
<p class="mc-no-item-placeholder-url" *ngIf="documentationUrl && documentationTextHelper">
  <a target="_blank" [href]="documentationUrl">{{documentationTextHelper}}</a>
</p>